import axios from "../../../../utils/axios-private";

export const getUserByUsername = (authData) => {
  return {
    type: "GET_USER_BY_USERNAME",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/user/get`;
      axios
        .post(
          url,
          { username: authData?.username },
          { signal: controller.signal }
        )
        .then((response) => {
          resolve({ response, authData });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
